export default "__VITE_ASSET__BTPpFM0X__"